var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarSlide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1038,
    height: 307,
    viewBox: "0 0 1038 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1020.16 67.1887C1020.16 67.1887 1009.16 62.1093 988.232 55.5674C988.188 55.5509 990.179 21.676 989.74 18.5687C988.239 19.4062 987.202 21.9898 987.202 21.9898C987.202 21.9898 979.992 52.4014 979.849 52.8556C962.075 48.3009 945.003 44.5147 924.822 40.3081C924.468 40.9884 959.199 54.946 977.131 61.3871C976.651 62.8833 964.937 91.1121 963.76 94.6842C963.644 96.6968 964.551 97.3894 964.551 97.3894C964.551 97.3894 985.055 64.994 985.55 63.5283C1007.3 69.3603 1018.21 71.5401 1018.21 71.5401C1032.26 73.6671 1020.17 67.1665 1020.17 67.1665",
    fill: "#EFF3F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-14.6849 208.285C195.095 16.7846 710.761 8.11775 911.095 35.2844C515.595 -48.7153 98.0945 80.2845 -34.9053 165.285C-129.239 252.451 -235.306 409.682 -14.6849 208.285Z",
    fill: "#EFF3F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSlide);
export default __webpack_public_path__ + "static/media/star-slide.04c96b5b4beff675970db9ec72de2ba0.svg";
export { ForwardRef as ReactComponent };